export default __webpack_public_path__ + "static/media/lds-logo_fi.eebf22f44b54eb06.svg";